module.exports = __webpack_public_path__ + "img/icon-nft-placeholder.b2df0833.png";